import { isFreeEmailDomain } from '@repo/lib';
import request from '@dashboard/services/request';

const { REACT_APP_API_URL: apiUrl } = process.env;

const signup = data =>
  request(`${apiUrl}/signup`, null, {
    body: JSON.stringify(data),
    method: 'POST',
  });

/**
 * Prefetch brand data for a domain before signup completes.
 * This warms the cache so brand data is ready when user reaches branding step.
 *
 * @param {string} domain - The email domain (e.g., 'acme.com')
 * @returns {Promise} - Resolves when prefetch is queued (or skipped)
 */
const prefetchBrandFromEmail = async domain => {
  // Skip generic email domains
  if (isFreeEmailDomain(domain)) {
    return { queued: false, reason: 'generic_email_domain' };
  }

  // Fire-and-forget request to prefetch endpoint
  const response = await fetch(`${apiUrl}/brand/prefetch`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify({ domain }),
  });

  if (!response.ok) {
    throw new Error(`Prefetch failed: ${response.status}`);
  }

  return response.json();
};

export { signup, prefetchBrandFromEmail };
